export default "__VITE_ASSET__DDvx4cHk__"